import * as React from 'react';

const styles = require('./OptInScene.scss');
const classNames = require('classnames/bind').bind(styles);

function SmartSuggestScene(props: {}) {
    const disableFormatDetection = ref => {
        ref && ref.setAttribute('x-ms-format-detection', 'none');
    };

    return (
        <div>
            <div className={classNames('prop', 'compose-box')}>
                <div className={classNames('prop', 'paragraph', 'alpha')}>Hey Miguel,</div>
                <div className={classNames('prop', 'paragraph', 'beta')}>
                    What should we do tonight? I was thinking <mark>Fourth Coffee</mark>.
                </div>
                <div className={classNames('prop', 'restaurant-card')}>
                    <div className={classNames('inner')}>
                        <div className={classNames('details')}>
                            <h1>Fourth Coffee</h1>
                            <div className={classNames('rating')}>212 Reviews</div>
                            <span>4:00 - 10:00 PM</span>
                            <span>4567 Main St, Buffalo</span>
                            <span ref={disableFormatDetection}>(716) 555-0199</span>
                        </div>
                        <div className={classNames('art')} data-version="1" />
                    </div>
                </div>
                <div className={classNames('prop', 'paragraph', 'gamma')}>
                    Let me know what you think.
                </div>
                <div className={classNames('prop', 'paragraph', 'delta')}>
                    Kat
                    <span className={classNames('i-beam')} />
                </div>
            </div>

            <div className={classNames('prop', 'sidebar')}>
                <div className={classNames('prop', 'sidebar-header')}>
                    Quick Suggestions
                    <i className="close" />
                </div>
                <div className={classNames('prop', 'cards')}>
                    <div className={classNames('prop', 'restaurant-card')}>
                        <div className={classNames('inner')}>
                            <div className={classNames('details')}>
                                <h1>Fourth Coffee</h1>
                                <div className={classNames('rating')}>212 Reviews</div>
                                <span>4:00 - 10:00 PM</span>
                                <span>4567 Main St, Buffalo</span>
                                <span ref={disableFormatDetection}>(716) 555-0199</span>
                            </div>
                            <div className={classNames('art')} data-version="1" />
                        </div>
                    </div>
                    <div className={classNames('prop', 'restaurant-card')}>
                        <div className={classNames('inner')}>
                            <div className={classNames('details')}>
                                <h1>Fourth Coffee</h1>
                                <div className={classNames('rating')}>153 Reviews</div>
                                <span>3:00 - 9:00 PM</span>
                                <span>1234 5th Ave, Buffalo</span>
                                <span ref={disableFormatDetection}>(716) 555-0122</span>
                            </div>
                            <div className={classNames('art')} data-version="2" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SmartSuggestScene;
